import axios from 'axios';

export default {
  isPhoneValid: {
    validate(value, args) {
      const MOBILE_REGEXP = /^(\s*)?(\+)?([- ()+]?\d[- ()+#]?){9,16}(\s*)?$/;
      return MOBILE_REGEXP.test(value);
    },
  },
  isEmailUnique: {
    validate(value, args) {
      return axios
        .get('/Employees/ValidateEmail?email=' + value + '&id=' + args[0])
        .then((response) => {
          return response.data;
        })
        .catch(() => {});
    },
  },
  isIddUnique: {
    validate(value, args) {
      return axios
        .get('/Donors/ValidateIdd?externalId=' + value + '&organizationId=' + args[0])
        .then((response) => {
          return response.data;
        })
        .catch(() => {});
    },
  },
  serviceCode: {
    validate(value, args) {
      const SERV_CODE = /^([A-Z]|[0-9]){3,16}$/;
      return SERV_CODE.test(value);
    },
  },

  isRoleNameUnique: {
    validate(value, args) {
      return axios
        .get(`/Roles/ValidateName?name=${value}&id=${args[0]}&group=${args[1]}`)
        .then((response) => {
          return response.data;
        })
        .catch(() => {});
    },
  },

  isAlleleValid: {
    validate(value, args) {
      return axios
        .get(`/ValidLocuses/Validate?value=${value}&type=${args[0]}&isDonor=${args[1]}`)
        .then(response => {
          return new Promise(resolve => {
            resolve({
              valid: response.data.isValid,
              data: response.data.message
            });
          });
        })
        .catch(() => {});
    }
  },

  isBillNumberUnique: {
    validate(value, args) {
      return axios
        .get("/Patients/ValidateBillNumber?value=" + value + "&patientId=" + args[0])
        .then(response => {
          return new Promise(resolve => {
            resolve({
              valid: response.data.isValid,
              data: response.data.message
            });
          });
        })
        .catch(() => {});
    }
  },

  isLocusGroupValid: {
    validate(value, args) {
      const LOCUS_GROUP_REGEXP = /^(([0-9]{2}):([0-9]{2,3}[A-Z]?)\/?)*$/;
      return LOCUS_GROUP_REGEXP.test(value);
    }
  },

  isGroupGCodeExist: {
    validate(value, args) {
      return axios
        .get("/GroupGCodes/IsExist?hlaType=" + args[0] + "&sourceG1=" + args[1] + "&sourceG2=" + args[2])
        .then(response => {
          return new Promise(resolve => {
            resolve({
              valid: response.data.isValid,
              data: response.data.message
            });
          });
        })
        .catch(() => {});
    }
  },

  addCustomValidation: function(validator) {
    validator.extend('isEmailUnique', this.isEmailUnique);
    validator.extend('isIddUnique', this.isIddUnique);
    validator.extend('isPhoneValid', this.isPhoneValid);
    validator.extend('serviceCode', this.serviceCode);
    validator.extend('isRoleNameUnique', this.isRoleNameUnique);
    validator.extend("isAlleleValid", this.isAlleleValid);   
    validator.extend("isLocusGroupValid", this.isLocusGroupValid);
    validator.extend("isGroupGCodeExist", this.isGroupGCodeExist);   
    validator.extend("isBillNumberUnique", this.isBillNumberUnique);   
  },
};
